import React from 'react';
import '../constants/AssetsCss';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GetORPostAsync from '../constants/restservice';
import withRouter from '../constants/withRouter';

class TeamList extends React.Component {
    constructor(props) {
        super(props);
        this.onfromDateChanged = this.onfromDateChanged.bind(this);
        this.ontoDateChanged = this.ontoDateChanged.bind(this);
        this.onsearch = this.onsearch.bind(this);
        this.state = {
            isActiveTeam: true,
            titleText: "Team List",
            fromDate: "",
            toDate: "",
            position: "left"
        }
    }
    onfromDateChanged(event) {
        this.setState({ fromDate: event.target.value });
    }
    ontoDateChanged(event) {
        this.setState({ toDate: event.target.value });
    }
    onsearch() {
        let json = {
            fromdate: this.state.fromDate,
            todate: this.state.toDate,
            position: this.state.position,
            Activestatus: this.props.history.location.state ? this.props.history.location.state.isActiveTeam ? "1" : "2" : "2"
        }
        this.getLeftTeam(JSON.stringify(json), true);
        // json.position = "right";
        // this.getLeftTeam(JSON.stringify(json), false);
    }
    componentDidMount() {
        this.setState({
            isActiveTeam: this.props.history.location.state ? this.props.history.location.state.isActiveTeam : false,
            titleText: this.props.history.location.state ? this.props.history.location.state.isActiveTeam ? "Active Team List" : "Team List" : "Team List"
        });
        let json = {
            position: this.state.position,
            Activestatus: this.props.history.location.state ? this.props.history.location.state.isActiveTeam ? "1" : "2" : "2"
        }
        this.getLeftTeam(JSON.stringify(json), true);
        // json.position = "right";
        // this.getLeftTeam(JSON.stringify(json), false);
    }
    async getLeftTeam(dates, leftOrRight) {
        this.setState({ directSponsorsTable: "" });
        let res = await GetORPostAsync("GetHirachyTable.asp", "POST", dates, localStorage.getItem("token"));
        let laststr = "";
        if (res.memberid1) {
            laststr += '<tr><td class="bg-color-1 text-white">' + (res.items ? res.items.length + 1 : 1) + '</td><td>' + res.memberid1 + '</td><td>' + res.memberidname1 + '</td><td>' + res.jdate1 + '</td><td>' + res.investment1 + '</td></tr>';
            leftOrRight ? this.setState({ leftTeamTable: laststr }) : this.setState({ RightTeamTable: laststr });
        }
        if (res.status === "error") {
            if (res.message === "Session Expired") {
                toast(res.message);
                this.props.history.push({
                    pathname: "/"
                });
            }
            if (leftOrRight && !res.memberid1) {
                this.setState({ leftTeamTable: "<tr><td colSpan='5'>No Records</td></tr>" });
            }
            return;
        }
        let str = "";
        for (let i = 0; i < res.items.length; i++) {
            str += '<tr><td class="bg-color-1 text-white">' + (i + 1) + '</td><td>' + res.items[i].memberid + '</td><td>' + res.items[i].memberidname + '</td><td>' + res.items[i].jdate + '</td><td>' + res.items[i].investment + '</td></tr>';
            if (i === res.items.length - 1) {
                if (leftOrRight) {
                    str += laststr;
                    this.setState({ leftTeamTable: str });
                }
            }
        }
    }
    render() {
        return (<div><div className="page-header">
            <div className="page-leftheader">
                <h4 className="page-title mb-0">Hi! {localStorage.getItem('fullname')}</h4>
                {/* <ol className="breadcrumb">
                    <li className="breadcrumb-item"><label><i className="fe fe-home mr-2 fs-14"></i>Main</label></li>
                    <li className="breadcrumb-item active" aria-current="page"><label>{this.state.titleText}</label></li>
                </ol> */}
            </div>
        </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title text-color-3" style={{ fontWeight: "200", fontSize: "22px" }}>{this.state.titleText}</h3>
                        </div>
                        <div className="d-md-flex mt-4 mb-2">
                            <div className="col-md-3">
                                <div className="form-group">
                                    <div className="input-group">
                                        <span className="input-group-prepend">
                                            <span className="input-group-text"><i className="fe fe-calendar"></i></span>
                                        </span>
                                        <input type="text" onFocus={(e) => {
                                            e.currentTarget.type = 'date';
                                            e.currentTarget.showPicker();
                                        }} placeholder="MM/DD/YYYY" onChange={this.onfromDateChanged} value={this.state.fromDate} className="form-control daterange-single" id="start_date" name="start_date" autoComplete="off" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <div className="input-group">
                                        <span className="input-group-prepend">
                                            <span className="input-group-text"><i className="fe fe-calendar"></i></span>
                                        </span>
                                        <input type="text" onFocus={(e) => {
                                            e.currentTarget.type = 'date';
                                            e.currentTarget.showPicker();
                                        }} placeholder="MM/DD/YYYY" onChange={this.ontoDateChanged} value={this.state.toDate} className="form-control daterange-single" id="end_date" name="end_date" autoComplete="off" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <div className="input-group">
                                        <span className="input-group-prepend">
                                            <span className="input-group-text"><i className="fe fe-calendar"></i></span>
                                        </span>
                                        <select onChange={(e) => {
                                            this.setState({ position: e.target.value })
                                        }} value={this.state.position} className="form-control">
                                            <option value="left">Left</option>
                                            <option value="right">Right</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 text-left">
                                <div className="form-group">
                                    <button type="button" className="btn bg-color-1" onClick={this.onsearch}> View </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 row ml-1">
                            <h4 className="text-color-3 ml-auto mr-auto">Default data showing only latest 60 days , use date selection for old records</h4>
                            <div className="table-responsive mb-5 mr-5">
                                <table style={{ textAlign: "center" }} className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top">
                                    <thead className="">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Member ID</th>
                                            <th>Member Name</th>
                                            <th>Date</th>
                                            <th>Package</th>
                                        </tr>
                                    </thead>
                                    <tbody dangerouslySetInnerHTML={{ __html: this.state.leftTeamTable }}>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

export default withRouter(TeamList);